<template>
  <b-modal id="editar-modal" :title="$t('vGrupos.editarGrupo')" centered ref="modalEditarGrupo" @hidden="resetModal"
    hide-footer size="lg">
    <form ref="form" @submit.stop.prevent="handleSubmitEdit" style="margin-top: -15px">
      <p class="text-danger" v-if="existeNombre">
        {{ $t("vGrupos.msgErrorNombreGrupo") }}
      </p>
      <label for="input-nombre-feedback">{{ $t("Gral.nombre") }}:</label>
      <b-form-input id="input-nombre" v-model="datosEditarGrupo.nombre" :state="validacionCampoNombre"
        aria-describedby="input-nombre-help input-nombre-feedback" trim @keyup="cambiarStateValidarCampo">
      </b-form-input>
      <b-form-invalid-feedback id="input-nombre-feedback">
        {{ $t("vGrupos.msgErrorGrupo") }}
      </b-form-invalid-feedback>
      <div class="row" :class="[
        validacionCampoNombre
          ? 'validacionCampoNombreMargin'
          : 'validacionCampoNombreSinMargin']">
        <b-col cols="12" sm="6">
          <b-btn class="w-100" @click="$bvModal.hide('editar-modal')" style="color: white">
            {{ $t("Gral.cancelar") }}
          </b-btn>
        </b-col>
        <b-col cols="12" sm="6" class="margin-top-div-boton-guardar">
          <b-btn variant="info" class="w-100" style="color: white" :disabled="!validacionCampoNombre" type="submit">
            {{ $t("vGrupos.guardarGrupo") }}
          </b-btn>
        </b-col>
      </div>
    </form>
  </b-modal>
</template>

<script>
import AreaDataService from "../../../services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";

export default {
  props: {
    datosEditarGrupo: {
      type: Object,
      default: () => ({ nombre: "", id: null, habilitado: false }),
    },
  },
  data() {
    return {
      existeNombre: false,
      campoValido: true,
      nameState: null,
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: sessionStorage.getItem("key"),
      oldNombreArea: "",
    };
  },

  computed: {
    validacionCampoNombre() {
      return this.campoValido && this.datosEditarGrupo?.nombre?.trim() !== "";
    },
  },

  methods: {
    showModal() {
      this.oldNombreArea = this.datosEditarGrupo.nombre;
      this.$refs.modalEditarGrupo.show();
    },

    resetModal() {
      this.nameState = null;
      this.campoValido = true;
      this.existeNombre = false;
    },

    cambiarStateValidarCampo() {
      if (!this.campoValido) {
        this.campoValido = true;
      }
    },

    async handleSubmitEdit() {
      try {
        const data = {
          id: this.datosEditarGrupo.id,
          nombre: this.datosEditarGrupo.nombre,
          habilitado: this.datosEditarGrupo.habilitado,
        };

        if (this.oldNombreArea !== data.nombre) {
          const exiseNombreRegistrado = await this.existeNombreGrupo(
            data.nombre
          );

          if (exiseNombreRegistrado) {
            this.existeNombre = true;
            this.campoValido = false;
            return;
          }
        }

        const response = await AreaDataService.create(data, this.key);
        if (response.status === 201) {
          this.$emit("actualizarTabla", response.status);
          this.accion = "Actualizó el grupo " + data.nombre;
          this.registrarAccion();
          this.alertSweet("success", this.$t("vGrupos.msgActualizar"));
          this.cerrarModal();
        }
      } catch (error) {
        console.error("Error al editar el grupo: ",error)
        this.alertSweet("error", this.$t("vGrupos.msgActualizarError"));
      }
    },

    cerrarModal() {
      this.campoValido = true;
      this.$refs.modalEditarGrupo.hide();
    },

    async existeNombreGrupo(nombre) {
      try {
        const response = await AreaDataService.getExisteAreaByNombre(
          nombre,
          this.key
        );
        return response.data;
      } catch (error) {
        console.warn("Ya existe un grupo con este nombre: ",error);
        this.alertSweet("error", this.$t("Gral.msgErrorActualizar"));
      }
    },

    async registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };

      try {
        await AccionesDataService.create(data, this.key);
      } catch (error) {
        console.error("Error al registrar la accion: ",error)
        this.alertSweet("error", this.$t("Gral.msgErrorDesconocido"));
      }
    },

    alertSweet(icon, message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message,
      });
    },
  },
};
</script>

<style>
.validacionCampoNombreMargin {
  margin-top: 8px;
}

.validacionCampoNombreSinMargin {
  margin-top: 0px;
}
</style>
